import type { ContactElements } from '@Types/Shared/Footer';

import { EmailIconFooter, LocalizationIconFilled, PhoneIconFooter } from '../../Icons';

export default function Contact(props: ContactElements) {
	const { address, phone, mail } = props;
	return (
		<div className='flex flex-col gap-5 '>
			{address?.city || address?.country || address?.number || address?.street || address?.zip ? (
				<p className='flex items-center gap-2'>
					<LocalizationIconFilled className='fill-minos-footer-text-color' />
					<p className='minos-footer-text-font mt-3 flex flex-col text-base tablet:minos-footer-text-font'>
						<span>
							{address?.street}
							{address?.number && <span aria-hidden>,</span>} {address?.number}{' '}
							{address?.zip && <span aria-hidden>-</span>} {address?.zip} {address?.city}
						</span>
						<span>{address?.country}</span>
					</p>
				</p>
			) : (
				''
			)}

			{mail && (
				<a className='flex items-center gap-2' href={`mailto:${mail}`}>
					<EmailIconFooter className='fill-minos-footer-text-color' />
					<span>{mail}</span>
				</a>
			)}

			{phone && (
				<a className='flex items-center gap-2' href={`tel:${phone}`}>
					<PhoneIconFooter className='fill-minos-footer-text-color' />
					<span>{phone}</span>
				</a>
			)}
		</div>
	);
}
